module.exports = __webpack_public_path__ + "static/conditions-effectively-treated-lymphatic-drainage-therapy-aa8b4cba3ed21bc5c81b67352d5cac3e.webp";